/**
 * Created by rickborst on 25/07/2017.
 */
import _ from 'lodash';

import {getInstance as getDataSources} from 'datasources';
import {DeviceStates, setDeviceState} from '../widgets/player';
import {attemptSessionRefresh} from 'store/actions/session';
import {PaymentStatus, setStatus as setPaymentStatus} from 'store/actions/payment';
import {getInstance as getStore} from 'store/store';
import { hashHistory } from 'react-router';
import AnalyticsEventsManager from 'utils/firebase/index.js';
import { ModalTypes ,setModalType, showModal } from '../modal';

import {
    ActiveViewStatuses,
    setActiveViewStatus
} from 'store/actions/viewtree';

import {
    updatePaymentDetails
} from 'store/actions/paymentdetails';

import {
    hideModal
} from 'store/actions/modal';
import {removeDevice} from '../device';

const ActionTypes = {
        SET_SETTINGS_STATE: 'SET_SETTINGS_STATE',
        SET_SETTINGS_SECTIONS: 'SET_SETTINGS_SECTIONS'
    },

    SettingStates = {
        INITIAL: 'INITIAL',
        LOADING: 'LOADING',
        REQUEST_FAILURE: 'REQUEST_FAILURE',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    },

    /**
     * Sets the settings state.
     *
     * @param {string} state - Settings state.
     * @returns {Object} Action object.
     */
    setSettingsState = function (state) {

        return {
            type: ActionTypes.SET_SETTINGS_STATE,
            state: state
        };
    },

    /**
     * Sets the settings state.
     *
     * @param {Object} sections - Settings sections.
     * @returns {Object} Action object.
     */
    setSettingsSections = function (sections) {

        return {
            type: ActionTypes.SET_SETTINGS_SECTIONS,
            sections: sections
        };
    },

    /**
     * Retrieves the settings sections from the datasources.
     *
     * @returns {Function} Action function.
     */
    getSettings = function () {
        let dataSources = getDataSources();

        return dispatch => {

            dispatch(setSettingsState(SettingStates.LOADING));

            dataSources.getSettings()
                .then(response => {
                    dispatch(setSettingsSections(response));
                    dispatch(setSettingsState(SettingStates.REQUEST_SUCCESS));
                    dispatch(setActiveViewStatus(ActiveViewStatuses.READY));
                })
                .catch(() => {
                    dispatch(setSettingsState(SettingStates.REQUEST_FAILURE));
                    dispatch(attemptSessionRefresh());
                    dispatch(setActiveViewStatus(ActiveViewStatuses.READY));
                    dispatch(setModalType(ModalTypes.ERROR));
                    dispatch(showModal());
                });
        };
    },

    /**
     * Deletes a device.
     *
     * @param {Object} device - Device object.
     * @returns {Function} Action function.
     */
    deleteDevice = function (device) {
        let dataSources = getDataSources();

        return dispatch => {
            dispatch(removeDevice(device));

            return dataSources.deleteDevice(device)
                .then(() => {
                    dispatch(getSettings());
                    dispatch(setDeviceState(DeviceStates.UNVERIFIED));
                });
        };
    },

    /**
     * Deletes multiple devices at once.
     *
     * @param {Object} devices - Device objects.
     * @returns {Function} Action function.
     */
    deleteDevices = function (devices) {
        let dataSources = getDataSources();

        return dispatch => {

            return dataSources.deleteDevices(devices)
                .then(() => {
                    dispatch(getSettings());
                    dispatch(setDeviceState(DeviceStates.UNVERIFIED));
                });
        };
    },

    /**
     * Cancels payment.
     *
     * @param {Object} paymentParams - Payment params.
     * @returns {Function} Action function.
     */
    cancelPayment = function (paymentParams) {
        let dataSources = getDataSources();

        let analytics = new AnalyticsEventsManager();

        return dispatch => {

            return dataSources.cancelPayment(paymentParams)
                .then(() => {
                        dispatch(updatePaymentDetails({
                            type: '',
                            renewable: false,
                            endDate: null,
                            method: '',
                            lastDigits: '',
                            subscriptionId: null,
                            paymentGatewayId: null,
                            subscriptionName: null,
                            isNeedHideCardSection: false
                        }));
                        dispatch(getSettings());
                        dispatch(hideModal());

                        analytics.sendCalcelSubscriptionEvent();
                        dispatch(setPaymentStatus(PaymentStatus.REQUEST_SUCCESS));
                        localStorage['isPaymentCancelled'] = true;
                        hashHistory.replace('/');
						console.trace("hashHistory.replace");

                }).catch((error) => {
                    dispatch(setPaymentStatus(PaymentStatus.REQUEST_FAILURE));
                    return Promise.reject(error);
                });
        };
    };


/**
 * Edit payment.
 *
 * @param {Object} paymentParams - Payment params.
 * @returns {Object} Action type and error object.
 */
function editPayment (paymentParams) {
    return () => {

        let dataSources = getDataSources(),
            failedRequestCallback = (response) => {
                let error = _.get(response, ['result', 'error']);

                if (error && (typeof error === 'string' || error.message)) {

                    error = typeof error === 'string'
                        ? error
                        : error.message;
                } else {

                    error = 'Unknown Error';
                }
                return error;
            };

        localStorage['isPaymentEditable'] = true;

        // get default payment gateway
        return dataSources.listPaymentGateways()
            .then((gateways) => {
                let defaultPaymentGateway = null;

                _.each(gateways, (gateway) => {
                    if (gateway.isDefaultGateway()) {
                        defaultPaymentGateway = gateway;
                    }
                });

                // in case none is default, pick first one
                if (!defaultPaymentGateway && gateways.length) {
                    defaultPaymentGateway = gateways[0];
                }

                return defaultPaymentGateway;

            }, failedRequestCallback)
            .then((defaultGateway) => {

                let addCardParams = {
                    defaultGateway: defaultGateway.id,
                    userId: paymentParams.userId,
                    subscriptionId: paymentParams.subscriptionId
                };

                return dataSources.addCard(addCardParams)
                    .then((redirectURL) => {

                        // REDIRECT to YAAD SARIG - template 2
                        if (redirectURL) {
                          // window.location.href = redirectURL + '&tmp=2';
                          console.trace(`window.location.href redirectURL + '&tmp=2';`);
                          hashHistory.push(`/payment-edit?s=${encodeURIComponent(redirectURL + "&tmp=2")}`);
                        }
                    });
            }, failedRequestCallback);
    };
}


export {
    ActionTypes,
    SettingStates,
    setSettingsState,
    setSettingsSections,
    getSettings,
    deleteDevice,
    deleteDevices,
    cancelPayment,
    editPayment
};



// WEBPACK FOOTER //
// ./src/js/store/actions/pages/settings.js